import { Injectable, ErrorHandler, Injector, NgModule, defineInjectable, inject } from '@angular/core';
import { ConfigManagerService, ConfigManagerModule, CONFIG_MANAGER_SERVICE_CONFIGURATION } from '@xpo-ltl/config-manager';
import { UUID } from 'angular2-uuid';
import { some, cloneDeep } from 'lodash';
import { takeUntil, distinctUntilChanged, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LogLevel } from '@xpo-ltl/sdk-common';
import { HttpClient, HttpHeaders, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseService } from '@xpo-ltl/data-api';
import { detect } from 'detect-browser';
import { inspect } from 'util';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/config-manager';
import * as ɵngcc2 from '@angular/common/http';
class LoggingConstants {
}
LoggingConstants.ActivityNames = {
    ApiGatewayCall: 'API Gateway Call',
};
LoggingConstants.ActionNames = {
    Request: 'request',
    Response: 'response',
    Error: 'error',
    Change: 'ValueChanged'
};
LoggingConstants.MESSAGE_TYPE = 'json';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Logging API
 * Version: 1.0
 * Build: Manual
 */
/**
 * Request to log.
 */
class InsertLogRqst {
    constructor() {
        /**
         * Details of what to log
         */
        this.Log = undefined;
    }
}
/**
 * Log record layout
 */
class Log {
    constructor() {
        this.hdr = undefined;
        this.bdy = undefined;
    }
}
class AnyType {
    constructor() {
        /**
         * Any data type. Use domain specific pre-defined types
         */
        this.data = undefined;
    }
}
class Body {
    constructor() {
        /**
         * Detailed contextual information for the logevent. eg: employee info, order detail info
         */
        this.detailedContext = undefined;
        /**
         * Map to technology specific process info ex:BWProcessInfoType
         */
        this.processInfo = undefined;
        /**
         * Map the technology specific error report ex:BWErrorReportType
         */
        this.errorRpt = undefined;
    }
}
class Header {
    constructor() {
        /**
         * This is the current timestamp that this logmessage is being created.
         */
        this.logTimestamp = undefined;
        this.logLevel = undefined;
        /**
         * This is the name of the orgainization e.g. XPO.
         */
        this.org = undefined;
        /**
         * This is the name of the division within the orge.g. LTL
         */
        this.div = undefined;
        /**
         * This is the envrionment within that division e.g.CTSI, CTS2, CTSS, PROD
         */
        this.env = undefined;
        /**
         * This is the layer within that env e.g. BW, BE,API, WAS
         */
        this.layer = undefined;
        /**
         * This is the name of the application that islogging
         */
        this.appName = undefined;
        /**
         * This is the name of the application instance thatis logging
         */
        this.appInstanceName = undefined;
        /**
         * This is the projectName from which this messageis being logged. This can be mapped from the projectName elementunder the $_processContext variable.
         */
        this.projectName = undefined;
        /**
         * specifies the core group the application belongsto e.g. S2C.OMS, P2D.SCO, S2C.SHM, B2B.EDI
         */
        this.appGroupName = undefined;
        /**
         * specifies the business function that this logrecord is related to e.g. Billing, Corrections, Invociing
         */
        this.busFuncName = undefined;
        /**
         * hostname of the logging application
         */
        this.hostName = undefined;
        /**
         * a unique id published by an app that associates abusiness transaction to a message or set of messages e.g shipmentpickup
         */
        this.correlationId = undefined;
        this.processName = undefined;
        this.processId = undefined;
        this.threadName = undefined;
        this.sessionName = undefined;
        this.lockKey = undefined;
        this.activityName = undefined;
        /**
         * short contextual information for this log event.e.g Order not billed in OMS
         */
        this.shortContext = undefined;
        this.tranType = undefined;
        this.action = undefined;
        this.eventType = undefined;
        /**
         * Optional return code
         */
        this.returnCode = undefined;
        /**
         * Optional reason code.
         */
        this.reasonCode = undefined;
        /**
         * Indicates whether this log event is a result ofretry operation. If not true, exception will be generated toclient - Used by BW clients
         */
        this.isRetry = undefined;
        /**
         * Indicates whether domain attributes i.e. key datais stored in job sharedvariable. If true logger utility will mapfields from key data jobshared variable - Used by BW clients
         */
        this.isDomainAttrbsInJobShrVar = undefined;
        /**
         * Domain speciific search attrivutes ex:ShipmentSearchType
         */
        this.domainAttrbs = undefined;
        /**
         * Use domain specific json string. Use this onlyafter exhausing the possiblities with domainAttrbs node
         */
        this.domainJson = undefined;
        /**
         * Map technoilogy search attributes ex:BWAttributes
         */
        this.appTechAttrbs = undefined;
        /**
         * Kafka configuration
         */
        this.kafkaConfig = undefined;
    }
}
class KafkaLogConfig {
    constructor() {
        /**
         * Kafka Topic Name to log this message
         */
        this.logTopicName = undefined;
        /**
         * If true creates new Kafka Config Instance,otherwise, reuses the existing config instance. Default is false.
         */
        this.isNewConfig = undefined;
        this.logBootStrapServers = undefined;
        this.logAckMode = undefined;
        this.lingerTimeMillisec = undefined;
        this.logBufferMemory = undefined;
        this.logRetries = undefined;
        this.logBatchSize = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoggingApiService {
    /**
     * @param {?} configManager
     */
    constructor(configManager) {
        this.configManager = configManager;
        this.subject = new Subject();
        this.logMap = {};
        this.configured = false;
        this.unsubscribe = new Subject();
        this.insertLogRqst = new InsertLogRqst();
        this.insertLogRqst.Log = new Log();
        this.configManager.configured$.pipe(takeUntil(this.unsubscribe)).subscribe(settings => {
            if (settings) {
                this.initHeader(settings);
                this.buildVersion = settings.buildVersion;
            }
        });
        this.initBody();
        this.logMap[LogLevel.DEBUG] = 1;
        this.logMap[LogLevel.INFO] = 2;
        this.logMap[LogLevel.WARN] = 3;
        this.logMap[LogLevel.ERROR] = 4;
        this.logMap[LogLevel.FATAL] = 5;
    }
    /**
     * @param {?} contextName
     * @param {?} value
     * @return {?}
     */
    setContext(contextName, value) {
        if (!this.insertLogRqst.Log.hdr.domainAttrbs) {
            this.insertLogRqst.Log.hdr.domainAttrbs = { data: {} };
        }
        this.insertLogRqst.Log.hdr.domainAttrbs.data[contextName] = value;
    }
    /**
     * @param {?} contextName
     * @return {?}
     */
    clearContext(contextName) {
        if (this.insertLogRqst.Log.hdr.domainAttrbs) {
            delete this.insertLogRqst.Log.hdr.domainAttrbs.data[contextName];
        }
    }
    /**
     * @param {?} userName
     * @param {?} browser
     * @return {?}
     */
    setUserContext(userName, browser) {
        if (!this.insertLogRqst.Log.hdr.domainAttrbs) {
            this.insertLogRqst.Log.hdr.domainAttrbs = { data: {} };
        }
        this.insertLogRqst.Log.hdr.domainAttrbs.data['userId'] = userName;
        this.insertLogRqst.Log.hdr.domainAttrbs.data['appVersion'] = this.buildVersion;
        this.insertLogRqst.Log.hdr.domainAttrbs.data['browserInfo'] = browser;
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    initHeader(settings) {
        if (settings) {
            this.insertLogRqst.Log.hdr = new Header();
            this.insertLogRqst.Log.hdr.domainAttrbs = { data: {} };
            this.insertLogRqst.Log.hdr.org = settings.logOrganization;
            this.insertLogRqst.Log.hdr.layer = settings.logLayer;
            this.insertLogRqst.Log.hdr.appName = settings.logAppName;
            this.insertLogRqst.Log.hdr.projectName = settings.logProjectName;
            this.insertLogRqst.Log.hdr.appInstanceName = UUID.UUID();
            this.configured = true;
            this.unsubscribe.next();
            this.unsubscribe.complete();
            this.unsubscribe = null;
        }
    }
    /**
     * @return {?}
     */
    initBody() {
        this.insertLogRqst.Log.bdy = new Body();
    }
    /**
     * @param {?} activityName
     * @param {?} transactionType
     * @param {?} httpResponse
     * @param {?} requestPath
     * @param {?} httpMethod
     * @param {?} elapsedTimeInMilliseconds
     * @param {?=} correlationId
     * @param {?=} message
     * @return {?}
     */
    logHttpStats(activityName, transactionType, httpResponse, requestPath, httpMethod, elapsedTimeInMilliseconds, correlationId, message) {
        if (!this.configured) {
            // TODO: WE COULD QUEUE.  FOR NOW JUST CONSOLE LOG
            console.log('Logging not yet configured.  Skipping log statement');
            return;
        }
        if (this.configManager.getSetting('logServicePerformance')) {
            const /** @type {?} */ logRequest = cloneDeep(this.insertLogRqst);
            logRequest.Log.hdr.env = this.configManager.getSetting('region');
            logRequest.Log.hdr.returnCode = `${httpResponse}`;
            logRequest.Log.hdr.eventType = httpMethod;
            logRequest.Log.hdr.tranType = transactionType;
            logRequest.Log.hdr.activityName = activityName;
            logRequest.Log.hdr.shortContext = requestPath;
            logRequest.Log.bdy.processInfo = { data: { elapsedTime: elapsedTimeInMilliseconds, messageType: LoggingConstants.MESSAGE_TYPE } };
            if (correlationId) {
                logRequest.Log.hdr.correlationId = correlationId;
            }
            if (message) {
                logRequest.Log.bdy.detailedContext = message;
            }
            logRequest.Log.hdr.logLevel = LogLevel.INFO;
            logRequest.Log.hdr.logTimestamp = new Date();
            this.subject.next(logRequest);
        }
    }
    /**
     * @param {?} body
     * @param {?} action
     * @param {?} activityName
     * @param {?} transactionType
     * @param {?} requestPath
     * @param {?} httpMethod
     * @param {?} logLevel
     * @param {?=} correlationId
     * @return {?}
     */
    logHttpRequestBody(body, action, activityName, transactionType, requestPath, httpMethod, logLevel, correlationId) {
        if (!this.configured) {
            // TODO: WE COULD QUEUE.  FOR NOW JUST CONSOLE LOG
            console.log('Logging not yet configured.  Skipping log statement');
            return;
        }
        const /** @type {?} */ logRequest = cloneDeep(this.insertLogRqst);
        logRequest.Log.hdr.env = this.configManager.getSetting('region');
        logRequest.Log.hdr.tranType = transactionType;
        logRequest.Log.hdr.eventType = httpMethod;
        logRequest.Log.hdr.activityName = activityName;
        logRequest.Log.hdr.shortContext = requestPath;
        logRequest.Log.hdr.action = action;
        if (correlationId) {
            logRequest.Log.hdr.correlationId = correlationId;
        }
        logRequest.Log.bdy.detailedContext = JSON.stringify(body);
        logRequest.Log.bdy.processInfo = { data: { messageType: LoggingConstants.MESSAGE_TYPE } };
        logRequest.Log.hdr.logLevel = logLevel;
        logRequest.Log.hdr.logTimestamp = new Date();
        this.subject.next(logRequest);
    }
    /**
     * @param {?} body
     * @param {?} action
     * @param {?} activityName
     * @param {?} transactionType
     * @param {?} requestPath
     * @param {?} httpMethod
     * @param {?} httpResponse
     * @param {?} elapsedTimeInMilliseconds
     * @param {?} logLevel
     * @param {?=} correlationId
     * @return {?}
     */
    logHttpResponseBody(body, action, activityName, transactionType, requestPath, httpMethod, httpResponse, elapsedTimeInMilliseconds, logLevel, correlationId) {
        if (!this.configured) {
            // TODO: WE COULD QUEUE.  FOR NOW JUST CONSOLE LOG
            console.log('Logging not yet configured.  Skipping log statement');
            return;
        }
        const /** @type {?} */ logRequest = cloneDeep(this.insertLogRqst);
        logRequest.Log.hdr.env = this.configManager.getSetting('region');
        logRequest.Log.hdr.returnCode = `${httpResponse}`;
        logRequest.Log.hdr.tranType = transactionType;
        logRequest.Log.hdr.eventType = httpMethod;
        logRequest.Log.hdr.activityName = activityName;
        logRequest.Log.hdr.shortContext = requestPath;
        logRequest.Log.hdr.action = action;
        if (correlationId) {
            logRequest.Log.hdr.correlationId = correlationId;
        }
        logRequest.Log.bdy.detailedContext = JSON.stringify(body);
        logRequest.Log.bdy.processInfo = {
            data: {
                elapsedTime: elapsedTimeInMilliseconds,
                messageType: LoggingConstants.MESSAGE_TYPE
            }
        };
        logRequest.Log.hdr.logLevel = logLevel;
        logRequest.Log.hdr.logTimestamp = new Date();
        this.subject.next(logRequest);
    }
    /**
     * @param {?} url
     * @param {?} elapsedTimeInMilliseconds
     * @param {?} activityName
     * @return {?}
     */
    logAppNavigation(url, elapsedTimeInMilliseconds, activityName) {
        if (!this.configured) {
            // TODO: WE COULD QUEUE.  FOR NOW JUST CONSOLE LOG
            console.log('Logging not yet configured.  Skipping log statement');
            return;
        }
        if (this.configManager.getSetting('logServicePerformance')) {
            const /** @type {?} */ logRequest = cloneDeep(this.insertLogRqst);
            logRequest.Log.hdr.env = this.configManager.getSetting('region');
            logRequest.Log.hdr.tranType = url;
            logRequest.Log.hdr.activityName = activityName;
            logRequest.Log.hdr.shortContext = url;
            logRequest.Log.bdy.processInfo = { data: { elapsedTime: elapsedTimeInMilliseconds } };
            logRequest.Log.hdr.logLevel = LogLevel.INFO;
            logRequest.Log.hdr.logTimestamp = new Date();
            logRequest.Log.hdr.projectName = this.configManager.getSetting('logProjectName');
            this.subject.next(logRequest);
        }
    }
    /**
     * Queues up a log request with the message details
     * @param {?} level
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    log(level, message, correlationId, action, activityName, transactionType) {
        if (!this.configured) {
            // TODO: WE COULD QUEUE.  FOR NOW JUST CONSOLE LOG
            console.log('Logging not yet configured.  Skipping log statement');
            return;
        }
        if (this.isLoggingEnabledFor(level)) {
            this.insertLogRqst.Log.hdr.env = this.configManager.getSetting('region');
            const /** @type {?} */ logRequest = cloneDeep(this.insertLogRqst);
            logRequest.Log.hdr.logLevel = level;
            logRequest.Log.hdr.logTimestamp = new Date();
            if (activityName) {
                logRequest.Log.hdr.activityName = activityName;
            }
            if (action) {
                logRequest.Log.hdr.action = action;
            }
            if (transactionType) {
                logRequest.Log.hdr.tranType = transactionType;
            }
            if (correlationId) {
                logRequest.Log.hdr.correlationId = correlationId;
            }
            logRequest.Log.bdy.detailedContext = message;
            this.subject.next(logRequest);
        }
    }
    /**
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    debug(message, correlationId, action, activityName, transactionType) {
        this.log(LogLevel.DEBUG, message, correlationId, action, activityName, transactionType);
    }
    /**
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    info(message, correlationId, action, activityName, transactionType) {
        this.log(LogLevel.INFO, message, correlationId, action, activityName, transactionType);
    }
    /**
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    warn(message, correlationId, action, activityName, transactionType) {
        this.log(LogLevel.WARN, message, correlationId, action, activityName, transactionType);
    }
    /**
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    error(message, correlationId, action, activityName, transactionType) {
        this.log(LogLevel.ERROR, message, correlationId, action, activityName, transactionType);
    }
    /**
     * @param {?} message
     * @param {?=} correlationId
     * @param {?=} action
     * @param {?=} activityName
     * @param {?=} transactionType
     * @return {?}
     */
    fatal(message, correlationId, action, activityName, transactionType) {
        this.log(LogLevel.FATAL, message, correlationId, action, activityName, transactionType);
    }
    /**
     * @param {?} logLevel
     * @return {?}
     */
    isLoggingEnabledFor(logLevel) {
        const /** @type {?} */ currentAppLogLevel = this.configManager.getSetting('esLogLevel') || LogLevel.ERROR;
        return (/** @type {?} */ (this.logMap[logLevel])) >= (/** @type {?} */ (this.logMap[currentAppLogLevel]));
    }
}
LoggingApiService.ɵfac = function LoggingApiService_Factory(t) { return new (t || LoggingApiService)(ɵngcc0.ɵɵinject(ɵngcc1.ConfigManagerService)); };
LoggingApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggingApiService, factory: LoggingApiService.ɵfac, providedIn: 'root' });
/** @nocollapse */
LoggingApiService.ctorParameters = () => [
    { type: ConfigManagerService }
];
/** @nocollapse */ LoggingApiService.ngInjectableDef = defineInjectable({ factory: function LoggingApiService_Factory() { return new LoggingApiService(inject(ConfigManagerService)); }, token: LoggingApiService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingApiService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoggingApiWorkerService extends BaseService {
    /**
     * @param {?} configManager
     * @param {?} loggingApiService
     * @param {?} http
     */
    constructor(configManager, loggingApiService, http) {
        super();
        this.configManager = configManager;
        this.loggingApiService = loggingApiService;
        this.http = http;
    }
    /**
     * @return {?}
     */
    init() {
        this.loggingApiService.subject.asObservable().subscribe((logRequest) => {
            if (!this.url) {
                this.url = this.createUrl();
            }
            this.http.post(this.url, logRequest, { headers: new HttpHeaders() })
                .subscribe(results => { }, error => console.log(JSON.stringify(error)));
        });
    }
    /**
     * @return {?}
     */
    createUrl() {
        const /** @type {?} */ apiUrl = this.configManager.getSetting('apiUrl');
        const /** @type {?} */ url = this.getUrl('logs');
        return `${apiUrl}${apiUrl.endsWith('/') ? '' : '/'}${url.startsWith('/') ? url.substring(1) : url}`;
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(LoggingApiWorkerService.loggingApiEndpoint);
    }
}
LoggingApiWorkerService.ɵfac = function LoggingApiWorkerService_Factory(t) { return new (t || LoggingApiWorkerService)(ɵngcc0.ɵɵinject(ɵngcc1.ConfigManagerService), ɵngcc0.ɵɵinject(LoggingApiService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
LoggingApiWorkerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggingApiWorkerService, factory: LoggingApiWorkerService.ɵfac, providedIn: 'root' });
LoggingApiWorkerService.loggingApiEndpoint = 'loggingApiEndpoint';
/** @nocollapse */
LoggingApiWorkerService.ctorParameters = () => [
    { type: ConfigManagerService },
    { type: LoggingApiService },
    { type: HttpClient }
];
/** @nocollapse */ LoggingApiWorkerService.ngInjectableDef = defineInjectable({ factory: function LoggingApiWorkerService_Factory() { return new LoggingApiWorkerService(inject(ConfigManagerService), inject(LoggingApiService), inject(HttpClient)); }, token: LoggingApiWorkerService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingApiWorkerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.ConfigManagerService }, { type: LoggingApiService }, { type: ɵngcc2.HttpClient }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoggingUserContextHttpInterceptor {
    /**
     * @param {?} loggingApiService
     * @param {?} configManagerService
     */
    constructor(loggingApiService, configManagerService) {
        this.loggingApiService = loggingApiService;
        this.configManagerService = configManagerService;
        this.unsubscribe$ = new Subject();
        this.configManagerService.configured$.pipe(takeUntil(this.unsubscribe$)).subscribe(config => {
            if (config) {
                this.userContextPath = config.userContextPath;
                this.unsubscribe$.next();
                this.unsubscribe$.complete();
                this.unsubscribe$ = null;
            }
        });
    }
    /**
     * @param {?} url
     * @return {?}
     */
    ValidURL(url) {
        return /^(http|https):\/\/[^ "]+$/.test(url);
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        if (!this.ValidURL(req.url)) {
            return next.handle(req);
        }
        const /** @type {?} */ url = new URL(req.url);
        return next.handle(req).pipe(distinctUntilChanged(), tap((response) => {
            if (response instanceof HttpResponse) {
                const /** @type {?} */ status = Number.parseInt(`${response['status']}`);
                const /** @type {?} */ is200 = (status & 200) === 200;
                const /** @type {?} */ isContextPath = this.isUserContextPath(url.pathname);
                const /** @type {?} */ isGet = req.method === 'GET';
                const /** @type {?} */ hasUserInfo = response && response.body && response.body.data && response.body.data.userId;
                if (isContextPath && is200 && isGet && hasUserInfo) {
                    const /** @type {?} */ browserInfo = detect();
                    this.loggingApiService.setUserContext(response.body.data.userId, `${browserInfo.name}-${browserInfo.version}`);
                    this.loggingApiService.info(`Session Info - Browser Name: ${browserInfo.name} - Browser Version:${browserInfo.version} - OS: ${browserInfo.os}`, null, null, 'Version Info');
                }
            }
        }, (err) => {
            throw err;
        }));
    }
    /**
     * @param {?} pathname
     * @return {?}
     */
    isUserContextPath(pathname) {
        return (!this.userContextPath) ? false : pathname.indexOf(this.userContextPath) >= 0;
    }
}
LoggingUserContextHttpInterceptor.ɵfac = function LoggingUserContextHttpInterceptor_Factory(t) { return new (t || LoggingUserContextHttpInterceptor)(ɵngcc0.ɵɵinject(LoggingApiService), ɵngcc0.ɵɵinject(ɵngcc1.ConfigManagerService)); };
LoggingUserContextHttpInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggingUserContextHttpInterceptor, factory: LoggingUserContextHttpInterceptor.ɵfac });
/** @nocollapse */
LoggingUserContextHttpInterceptor.ctorParameters = () => [
    { type: LoggingApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingUserContextHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: LoggingApiService }, { type: ɵngcc1.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoggingHttpInterceptor {
    /**
     * @param {?} loggingApiService
     * @param {?} injector
     * @param {?} configManager
     */
    constructor(loggingApiService, injector, configManager) {
        this.loggingApiService = loggingApiService;
        this.injector = injector;
        this.configManager = configManager;
        this.logStatsPaths = undefined;
        this.logRequestPaths = undefined;
        this.logResponsePaths = undefined;
        this.logExclusionPaths = undefined;
        this.unsubscribe$ = new Subject();
        this.configManager.configured$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(config => {
            if (config) {
                this.logStatsPaths = config.logStatsForPaths;
                this.logRequestPaths = config.logRequestBodyForPaths;
                this.logResponsePaths = config.logResponseBodyForPaths;
                this.logExclusionPaths = config.logExclusionForPaths;
                this.unsubscribe$.next();
                this.unsubscribe$.complete();
                this.unsubscribe$ = null;
            }
        });
    }
    /**
     * @param {?} url
     * @return {?}
     */
    ValidURL(url) {
        return /^(http|https):\/\/[^ "]+$/.test(url);
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        if (!this.ValidURL(req.url)) {
            return next.handle(req);
        }
        const /** @type {?} */ url = new URL(req.url);
        const /** @type {?} */ start = new Date();
        if (req.url.indexOf(this.configManager.getSetting(LoggingHttpInterceptor.loggingApiEndpointKey)) >= 0) {
            return next.handle(req);
        }
        if (this.shouldLogRequest(url.pathname)) {
            this.logJsonRequest(req.body, 'request', req, url);
        }
        return next.handle(req).pipe(distinctUntilChanged(), tap(response => {
            if (response instanceof HttpResponse) {
                if (this.shouldLogResponse(url.pathname)) {
                    this.logJsonResponse(response, 'response', req, /** @type {?} */ (response['status']), start, url, LogLevel.DEBUG);
                }
                else if (this.shouldLogStats(url.pathname)) {
                    this.logStats(req, /** @type {?} */ (response['status']), start, url);
                }
            }
        }, (err) => {
            // log if there is an error
            if (this.shouldLogErrorResponse()) {
                this.logJsonResponse(err, 'error', req, err.status, start, url, LogLevel.ERROR);
            }
            throw err;
        }));
    }
    /**
     * @param {?} pathname
     * @param {?=} logLevel
     * @return {?}
     */
    shouldLogResponse(pathname, logLevel = LogLevel.DEBUG) {
        return (this.loggingApiService.isLoggingEnabledFor(logLevel) &&
            !this.containsPath(LoggingHttpInterceptor.doNotLogRequestPaths, pathname) &&
            !this.containsPath(this.logExclusionPaths, pathname) &&
            this.containsPath(this.logResponsePaths, pathname));
    }
    /**
     * @param {?} pathname
     * @param {?=} logLevel
     * @return {?}
     */
    shouldLogRequest(pathname, logLevel = LogLevel.DEBUG) {
        return (this.loggingApiService.isLoggingEnabledFor(logLevel) &&
            !this.containsPath(LoggingHttpInterceptor.doNotLogRequestPaths, pathname) &&
            !this.containsPath(this.logExclusionPaths, pathname) &&
            this.containsPath(this.logRequestPaths, pathname));
    }
    /**
     * @param {?} pathname
     * @param {?=} logLevel
     * @return {?}
     */
    shouldLogStats(pathname, logLevel = LogLevel.DEBUG) {
        return (this.loggingApiService.isLoggingEnabledFor(logLevel) &&
            !this.containsPath(this.logExclusionPaths, pathname) &&
            this.containsPath(this.logStatsPaths, pathname));
    }
    /**
     * @param {?=} logLevel
     * @return {?}
     */
    shouldLogErrorResponse(logLevel = LogLevel.ERROR) {
        return this.loggingApiService.isLoggingEnabledFor(logLevel);
    }
    /**
     * @param {?} paths
     * @param {?} pathname
     * @return {?}
     */
    containsPath(paths, pathname) {
        return some(paths, p => {
            if (p[0] === '$' && p.length > 1) {
                // compare regex
                return pathname.match(new RegExp(p.slice(1)));
            }
            else {
                // compare string literal
                return pathname.startsWith(p) || p === '*';
            }
        });
    }
    /**
     * @param {?} req
     * @param {?} responseCode
     * @param {?} start
     * @param {?} url
     * @param {?=} responseCorrelationId
     * @return {?}
     */
    logStats(req, responseCode, start, url, responseCorrelationId) {
        const /** @type {?} */ end = new Date();
        let /** @type {?} */ correlationId;
        if (req && req.headers && req.headers.has('x-correlation-id')) {
            correlationId = req.headers.get('x-correlation-id');
        }
        const /** @type {?} */ elapsedTime = end.getTime() - start.getTime();
        const /** @type {?} */ requestPath = req.url;
        const /** @type {?} */ transactionType = url.pathname;
        this.loggingApiService.logHttpStats(LoggingConstants.ActivityNames.ApiGatewayCall, transactionType, responseCode, requestPath, req.method, elapsedTime, responseCorrelationId || correlationId);
    }
    /**
     * @param {?} body
     * @param {?} action
     * @param {?} req
     * @param {?} url
     * @param {?=} logLevel
     * @return {?}
     */
    logJsonRequest(body, action, req, url, logLevel = LogLevel.DEBUG) {
        let /** @type {?} */ correlationId;
        if (req.headers.has('x-correlation-id')) {
            correlationId = req.headers.get('x-correlation-id');
        }
        const /** @type {?} */ requestPath = req.url;
        const /** @type {?} */ transactionType = url.pathname;
        this.loggingApiService.logHttpRequestBody(body, action, LoggingConstants.ActivityNames.ApiGatewayCall, transactionType, requestPath, req.method, logLevel, correlationId);
    }
    /**
     * @param {?} body
     * @param {?} action
     * @param {?} req
     * @param {?} responseCode
     * @param {?} start
     * @param {?} url
     * @param {?=} logLevel
     * @return {?}
     */
    logJsonResponse(body, action, req, responseCode, start, url, logLevel = LogLevel.DEBUG) {
        const /** @type {?} */ end = new Date();
        let /** @type {?} */ correlationId;
        if (req.headers.has('x-correlation-id')) {
            correlationId = req.headers.get('x-correlation-id');
        }
        const /** @type {?} */ elapsedTime = end.getTime() - start.getTime();
        const /** @type {?} */ requestPath = req.url;
        const /** @type {?} */ transactionType = url.pathname;
        this.loggingApiService.logHttpResponseBody(body, action, LoggingConstants.ActivityNames.ApiGatewayCall, transactionType, requestPath, req.method, responseCode, elapsedTime, logLevel, correlationId);
    }
}
LoggingHttpInterceptor.ɵfac = function LoggingHttpInterceptor_Factory(t) { return new (t || LoggingHttpInterceptor)(ɵngcc0.ɵɵinject(LoggingApiService), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc1.ConfigManagerService)); };
LoggingHttpInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggingHttpInterceptor, factory: LoggingHttpInterceptor.ɵfac });
LoggingHttpInterceptor.loggingApiEndpointKey = 'loggingApiEndpoint';
LoggingHttpInterceptor.doNotLogRequestPaths = ['/token', '$(/dmstoken)$'];
/** @nocollapse */
LoggingHttpInterceptor.ctorParameters = () => [
    { type: LoggingApiService },
    { type: Injector },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: LoggingApiService }, { type: ɵngcc0.Injector }, { type: ɵngcc1.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class GlobalErrorHandlingLogger extends ErrorHandler {
    /**
     * @param {?} injector
     * @param {?} loggingApiService
     * @param {?} configManager
     */
    constructor(injector, loggingApiService, configManager) {
        super();
        this.injector = injector;
        this.loggingApiService = loggingApiService;
        this.configManager = configManager;
        this.logErrors = false;
        this.unsubscribe$ = new Subject();
        this.configManager.configured$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((settings) => {
            if (settings) {
                this.logErrors = settings[GlobalErrorHandlingLogger.logUnhandledErrorsKey] || false;
                this.unsubscribe$.next();
                this.unsubscribe$.complete();
                this.unsubscribe$ = null;
            }
        });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleError(error) {
        let /** @type {?} */ logMessage;
        if (this.logErrors && this.loggingApiService) {
            try {
                logMessage = inspect(error);
            }
            catch (/** @type {?} */ err) {
                if (error['rejection'] && error['rejection']['stack']) {
                    logMessage = error.rejection.stack;
                }
                else {
                    logMessage = 'Unknown unhandled error occurred!';
                }
            }
            this.loggingApiService.fatal(logMessage);
            super.handleError(error);
        }
        else {
            console.log(error);
        }
    }
}
GlobalErrorHandlingLogger.ɵfac = function GlobalErrorHandlingLogger_Factory(t) { return new (t || GlobalErrorHandlingLogger)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(LoggingApiService), ɵngcc0.ɵɵinject(ɵngcc1.ConfigManagerService)); };
GlobalErrorHandlingLogger.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GlobalErrorHandlingLogger, factory: GlobalErrorHandlingLogger.ɵfac });
GlobalErrorHandlingLogger.logUnhandledErrorsKey = 'logUnhandledErrors';
/** @nocollapse */
GlobalErrorHandlingLogger.ctorParameters = () => [
    { type: Injector },
    { type: LoggingApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalErrorHandlingLogger, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: LoggingApiService }, { type: ɵngcc1.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkLoggingModule {
    /**
     * @param {?} loggingApi
     */
    constructor(loggingApi) {
        this.loggingApi = loggingApi;
        this.loggingApi.init();
    }
}
SdkLoggingModule.ɵfac = function SdkLoggingModule_Factory(t) { return new (t || SdkLoggingModule)(ɵngcc0.ɵɵinject(LoggingApiWorkerService)); };
SdkLoggingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkLoggingModule });
SdkLoggingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: HTTP_INTERCEPTORS, useClass: LoggingHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoggingUserContextHttpInterceptor, multi: true },
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
        { provide: ErrorHandler, useClass: GlobalErrorHandlingLogger }
    ], imports: [[
            ConfigManagerModule
        ]] });
/** @nocollapse */
SdkLoggingModule.ctorParameters = () => [
    { type: LoggingApiWorkerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkLoggingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    { provide: HTTP_INTERCEPTORS, useClass: LoggingHttpInterceptor, multi: true },
                    { provide: HTTP_INTERCEPTORS, useClass: LoggingUserContextHttpInterceptor, multi: true },
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                    { provide: ErrorHandler, useClass: GlobalErrorHandlingLogger }
                ]
            }]
    }], function () { return [{ type: LoggingApiWorkerService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkLoggingModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkLoggingModule, LoggingApiService, InsertLogRqst, Log, AnyType, Body, Header, KafkaLogConfig, GlobalErrorHandlingLogger as ɵc, LoggingApiWorkerService as ɵd, LoggingHttpInterceptor as ɵa, LoggingUserContextHttpInterceptor as ɵb };

